
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-scroller-demo-plugin-scroller"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.en.md?type=demo')
};